import React, { useContext } from 'react'
import { InitializeContext } from '../../../App';
import { FiExternalLink } from 'react-icons/fi';
import { BsLink45Deg } from 'react-icons/bs';

type PortfolioCardProps = {
          image: string;
          title: string;
          category: string;
          live: string;
          client: string | undefined;
          server: string | undefined;
};


export default function PortfolioCard({ image, title, live, client, server }: PortfolioCardProps) {
          const { theme } = useContext(InitializeContext);
          return (
                    <div className={`w-full ${theme ? 'bg-black' : 'bg-white'} p-4 md:pt-5 rounded-xl shadow-md flex flex-col`}>
                              <div style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover' }} className="w-full h-[13rem] md:h-[16rem] lg:h-[14rem] overflow-hidden select-none rounded-lg glass bg-top hover:bg-bottom scroll-smooth duration-[4000ms]"></div>
                              <div className="w-full mt-5 flex flex-col gap-3">
                                        <h3 className="text-sm md:text-base font-semibold uppercase">
                                                  {title}
                                        </h3>
                                        <div className='grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-3'>
                                                  <a href={live} target='_blank' rel="noreferrer" className={`flex items-center font-semibold gap-1 text-xs py-3 w-full shadow-md glass duration-500 rounded-xl ${theme ? 'text-white bg-[#212428] hover:bg-warning hover:text-white' : 'bg-white hover:bg-primary hover:text-white text-black'} inline-flex justify-center items-center duration-300 cursor-pointer`}>
                                                            <FiExternalLink /> Live Site
                                                  </a>
                                                  <a href={client} target='_blank' rel="noreferrer" className={`flex items-center font-semibold gap-1 text-xs py-3 w-full shadow-md glass duration-500 rounded-xl ${theme ? 'text-white bg-[#212428] hover:bg-warning hover:text-white' : 'bg-white hover:bg-primary hover:text-white text-black'} inline-flex justify-center items-center duration-300 cursor-pointer`}>
                                                            <BsLink45Deg size={15} /> Client
                                                  </a>
                                                  {
                                                            server && (
                                                                      <a href={server} target='_blank' rel="noreferrer" className={`flex items-center font-semibold gap-1 text-xs py-3 w-full shadow-md glass duration-500 rounded-xl ${theme ? 'text-white bg-[#212428] hover:bg-warning hover:text-white' : 'bg-white hover:bg-primary hover:text-white text-black'} inline-flex justify-center items-center duration-300 cursor-pointer`}>
                                                                                <BsLink45Deg size={15} /> Server
                                                                      </a>
                                                            )
                                                  }
                                        </div>
                              </div>
                    </div>
          );
}